<script setup lang="ts">
import { computed } from 'vue'
import { formatCurrency } from '~/utils/formatters'

interface SalaryRange {
  min: number
  max: number
}
interface CityData {
  city: string
  state: string
  state_full?: string
  median_salary: number
  salary_range: SalaryRange
  url?: string
  sample_size?: number
}
const props = defineProps<{
  cityData: CityData
}>()
const formattedMedianSalary = computed(() =>
  formatCurrency(props.cityData.median_salary)
)
const formattedMinSalary = computed(() =>
  formatCurrency(props.cityData.salary_range.min)
)
const formattedMaxSalary = computed(() =>
  formatCurrency(props.cityData.salary_range.max)
)
</script>

<template>
  <tr class="hover:bg-gray-50">
    <td class="px-6 py-4 whitespace-nowrap">
      <NuxtLink
        :to="cityData.url"
        :prefetch="false"
        class="text-primary-700 hover:text-primary-900 underline"
      >
        {{ cityData.city }}, {{ cityData.state }}
      </NuxtLink>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-gray-900">
      {{ formattedMedianSalary }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-gray-900">
      {{ formattedMinSalary }} - {{ formattedMaxSalary }}
    </td>
  </tr>
</template>
